/**
 * 最大カラムスパン値
 */
export const maxColSpanValue = 7;

/**
 * colSpanに応じたTailwindクラス名のマッピング
 */
export const colSpanClasses = {
  1: "col-span-1",
  2: "col-span-2",
  3: "col-span-3",
  4: "col-span-4",
  5: "col-span-5",
  6: "col-span-6",
  7: "col-span-7",
} as const;

/**
 * AttributeCardProps等で使用するcolSpanの型定義のためのヘルパー型
 */
type IntegerRange<
  T extends number,
  Acc extends number[] = [1],
> = Acc["length"] extends T
  ? Acc[number] | T
  : IntegerRange<T, [...Acc, Acc["length"]]>;

/**
 * カラムスパン値の型定義（1〜maxColSpanValueの整数）
 */
export type ColSpan = IntegerRange<typeof maxColSpanValue>;

/**
 * 値がColSpan型かどうかを判定する型ガード関数
 */
export function isColSpan(value: unknown): value is ColSpan {
  return (
    typeof value === "number" &&
    Number.isInteger(value) &&
    value >= 1 &&
    value <= maxColSpanValue
  );
}

/**
 * 値を安全にColSpan型に変換する関数
 * 不正な値の場合はデフォルト値を返す
 *
 * @param value - 変換する値
 * @param defaultValue - 不正な値の場合に返すデフォルト値（デフォルト: 2）
 * @returns ColSpan型の値
 */
export function toColSpan(
  value: number | null | undefined,
  defaultValue: ColSpan = 2,
): ColSpan {
  if (value == null) {
    return defaultValue;
  }
  return isColSpan(value) ? value : defaultValue;
}
